module.exports = __webpack_public_path__ + "img/nav_pic_light.e642e4b3.png";